import React from 'react';
import './StoreChips.css';

const StoreChips = ({ stores, selectedStore, onStoreSelect }) => {
  return (
    <div className="store-chips-container">
      <div className="store-chips-scroll">
        {stores.map((store) => {
          const isSelected = selectedStore === store;
          return (
            <button
              key={store}
              className={`store-chip ${isSelected ? 'selected' : ''}`}
              onClick={() => onStoreSelect(store)}
            >
              {store}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StoreChips;

